export function findProvinceFromAddress(addressPlace: any) {
    const addressComponents = addressPlace.address_components;
    let province: string = '';
    if (addressComponents) {
      const provinceComponent = addressComponents.find(component =>
        component.types.includes('administrative_area_level_2')
      );
      province = provinceComponent ? provinceComponent.short_name : '';
    }
    return province;
}

export function getCityFromAddressComponents(components: google.maps.GeocoderAddressComponent[] | undefined): string | null {
  if (!components) return null;

  const cityComponent = components.find(c =>
    c.types.includes('locality') ||
    c.types.includes('postal_town') ||
    c.types.includes('administrative_area_level_3')
  );

  return cityComponent?.long_name || null;
}
